import { useCallback, useState } from "react"

export function useOpenedState(initialOpened: boolean): [boolean, () => void] {
    const [opened, setOpened] = useState(initialOpened)

    const toggleOpen: () => void = useCallback(() => setOpened(prev => !prev), [])

    return [opened, toggleOpen]
}
